<template>
  <div class="bg-white absolute top-0 bottom-0 h-full w-full z-50" v-if="showMicroMenu">
    <div class="relative w-full h-16">
      <img v-if="showMicroMenu" @click="displaySubMenu()" class="back-icon cursor-pointer absolute" src="../../../assets/img/arrow.svg" height="50" width="30" alt="">
      <img v-if="showMicroMenu" @click="displayMainPage(false)" class="close-icon cursor-pointer absolute" src="../../../assets/img/close.svg" height="30" width="20" alt="">
      <p class="title absolute px-4 py-4 text-2xl">{{$store.state.Global.currentSelectedMicroMenu}}</p>
    </div>
    <ul class="sub-navigation px-4 py-2">
      <li class="px-4 py-2 mb-2" :class="{'current-route': $route.name.includes(menu.key.toLowerCase())}" v-for="menu in getMenuContent">
        <a :href="menu.url">{{menu.key}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { findIndex } from 'lodash';
import Constants from '../../../Constants';

export default {
  name: 'MicroPageNavigation',
  data() {
    return {
      menus: { ...Constants },
    };
  },
  computed: {
    currentSelected() {
      return this.$store.state.Global.currentSelectedSubMenu;
    },
    getMenuContent() {
      const subMenu = this.menus.subMenu[this.currentSelected];
      const index = findIndex(subMenu, { key: this.$store.state.Global.currentSelectedMicroMenu });

      if (index >= 0) {
        return this.menus.subMenu[this.currentSelected][index].microMenu;
      }

      return [];
    },
    showMicroMenu() {
      return this.$store.state.Global.microMobileMenu;
    },
  },
  methods: {
    async displaySubMenu() {
      await this.$store.commit('Global/setProperty', { property: 'microMobileMenu', payload: false });
      await this.$store.commit('Global/setProperty', { property: 'subMobileMenu', payload: true });
    },

    async displayMainPage(value) {
      await this.$store.commit('Global/setProperty', { property: 'microMobileMenu', payload: value });
    },
  },
};
</script>

<style scoped lang="scss">
.close-icon {
  right: 20px;
  top: 20px;
}

.back-icon {
  left: 20px;
  top: 20px;
}

.title {
  left: 70px;
}

.sub-navigation {
  li {
    cursor: pointer;

    &:hover {
      background: #ecf5ff;
    }
  }
}
</style>
